import { Component, EventEmitter, Input, Output, ViewChild, TemplateRef, OnChanges, SimpleChanges, ElementRef, Renderer2, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent, DrawerService } from '@portals/core';
import { NgImgEditorService, NgxCroppedEvent } from 'ng-img-editor';
import { base64ToFile } from 'ngx-image-cropper';
import { Ng2ImgMaxService } from 'ng2-img-max';
import * as moment from 'moment';

@Component({
	selector: 'portals-video-uploader',
	templateUrl: './video-uploader.component.html',
	styleUrls: ['./video-uploader.component.scss'],
})
export class VideoUploaderComponent extends BaseComponent {
	@Input() video: any;
	@Input() videoUpload!: any;
	@Input() videoData: any;
	@Input() videoThumbnail: any;
	@Output() videoEmitter = new EventEmitter();

	@ViewChild('fileUploadExceedDialog', { static: true })
	fileUploadExceedDialog!: TemplateRef<any>;

	constructor(public drawer: DrawerService<Record<string, unknown>>, public dialog: MatDialog, private editorService: NgImgEditorService) {
		super();
	}

	onVideoChanged(event: Event) {
		const inputElement = event.target as HTMLInputElement;
		const file = inputElement.files?.[0];

		if (!file) {
			return;
		}

		this.videoData = file;

		const reader = new FileReader();
		reader.readAsDataURL(file);

		reader.onload = async () => {
			const videoUrl = reader.result as string;
			this.video = videoUrl;

			return this.getThumbnailForVideo(this.video).then((video) => {
				(this.videoThumbnail = <string>video.thumbnailUrl),
					this.videoEmitter.emit({
						videoToUpload: this.videoData,
						videoToView: this.video,
						videoThumbnail: this.videoThumbnail,
						videoThumbnailData: video.thumbnail,
					});
			});
		};
	}

	async getThumbnailForVideo(videoUrl: string) {
		const video = document.createElement('video');
		const canvas = document.createElement('canvas');
		video.style.display = 'none';
		canvas.style.display = 'none';

		// Trigger video load
		await new Promise<void>((resolve, reject) => {
			video.addEventListener('loadedmetadata', () => {
				video.width = video.videoWidth;
				video.height = video.videoHeight;
				canvas.width = video.videoWidth;
				canvas.height = video.videoHeight;
				// Seek the video to 25%
				video.currentTime = video.duration * 0.25;
			});
			video.addEventListener('seeked', () => resolve());
			video.src = videoUrl;
		});

		// Draw the thumbnail
		canvas.getContext('2d')?.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
		const imageUrl = canvas.toDataURL('image/png');
		const image = {
			thumbnail: this.dataURLtoFile(<string>imageUrl, `${+new Date()}.jpg`),
			thumbnailUrl: imageUrl,
		};
		return image;
	}

	dataURLtoFile(dataurl: string, filename: string) {
		const arr = dataurl.split(',');
		const mimeMatch = arr[0].match(/:(.*?);/);
		const mime = mimeMatch ? mimeMatch[1] : '';
		const bstr = atob(arr[1]);
		const n = bstr.length;
		const u8arr = new Uint8Array(n);
		for (let i = 0; i < n; i++) {
			u8arr[i] = bstr.charCodeAt(i);
		}
		return new File([u8arr], filename, { type: <string>mime });
	}
}
